import {
  DataModel, DataModelBuilder, SerializationContext, SerializedData,
} from '../dto/data-model.js';
import { MapUtils } from '../../utility/map-utils.js';

export class TicketSupplementRef extends DataModel {
  static readonly TYPE_ID: string = 'b2c2280bafd647f3b5a4a65242f91b27';

  private constructor(
    public readonly ticketId: string,
    public readonly orderEntryId: string,
  ) {
    super();
  }

  get $typeId(): string {
    return TicketSupplementRef.TYPE_ID;
  }

  static create(params: {
    ticketId: string,
    orderEntryId: string,
  }): TicketSupplementRef {
    return new TicketSupplementRef(
        params.ticketId,
        params.orderEntryId,
    );
  }

  static fromMap(
      context: SerializationContext,
      map: SerializedData,
  ): TicketSupplementRef {
    return this.create({
      ticketId: MapUtils.getString(map, 'ticketId'),
      orderEntryId: MapUtils.getString(map, 'orderEntryId'),
    });
  }

  toMap(_context: SerializationContext): SerializedData {
    return {
      ticketId: this.ticketId,
      orderEntryId: this.orderEntryId,
    };
  }

  clone(): this {
    return this.copyWith();
  }

  copyWith({
    ticketId = this.ticketId,
    orderEntryId = this.orderEntryId,
  }: {
    ticketId?: string,
    orderEntryId?: string,
  } = {}): this {
    return TicketSupplementRef.create({
      ticketId,
      orderEntryId,
    }) as this;
  }

  isSame(other: this): boolean {
    return other.ticketId === this.ticketId;
  }
}

export class TicketSupplementRefBuilder extends DataModelBuilder<TicketSupplementRef> {
  build(context: SerializationContext, map: SerializedData): TicketSupplementRef {
    return TicketSupplementRef.fromMap(context, map);
  }
}
